import { render, staticRenderFns } from "./TabClassifiscFiscal.vue?vue&type=template&id=11f20c30&"
import script from "./TabClassifiscFiscal.vue?vue&type=script&lang=js&"
export * from "./TabClassifiscFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports